var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex flex-row items-center p-2"},[_c('Icon',{staticClass:"w-5 h-5 text-dark mr-2",attrs:{"icon":_vm.item.icon}}),_c('p',{staticClass:"text-dark text-base"},[_vm._v(_vm._s(_vm.item.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }